const isTrue = value => String(value || '').toLowerCase() === 'true';

const isRuntimeDebugEnabled = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const globalFlag = window.__SHIPPO_LABEL_DEBUG__ === true;
    const storageFlag = isTrue(window.localStorage?.getItem('SHIPPO_LABEL_DEBUG'));
    return globalFlag || storageFlag;
  } catch (_error) {
    return false;
  }
};

export const isShippoLabelDebugEnabled = () => {
  const envFlag =
    (typeof process !== 'undefined' && isTrue(process.env.REACT_APP_SHIPPO_LABEL_DEBUG)) ||
    (typeof process !== 'undefined' && isTrue(process.env.SHIPPO_LABEL_DEBUG));
  return envFlag || isRuntimeDebugEnabled();
};

const toSerializableError = error => {
  if (!error) {
    return null;
  }

  return {
    name: error?.name || null,
    message: error?.message || null,
    stack: error?.stack || null,
    status: error?.status || error?.statusCode || null,
    statusText: error?.statusText || null,
    responseBody: error?.response?.data || error?.response?.body || error?.body || null,
  };
};

const logWithLevel = (level, scope, message, payload) => {
  if (!isShippoLabelDebugEnabled()) {
    return;
  }

  const prefix = `[SHIPPO_DEBUG][${scope}] ${message}`;
  if (payload === undefined) {
    // eslint-disable-next-line no-console
    console[level](prefix);
  } else {
    // eslint-disable-next-line no-console
    console[level](prefix, payload);
  }
};

export const shippoDebugLog = (scope, message, payload) => {
  logWithLevel('log', scope, message, payload);
};

export const shippoDebugError = (scope, message, error, payload = {}) => {
  logWithLevel('error', scope, message, {
    ...payload,
    error: toSerializableError(error),
  });
};
